<template>
  <div>
    <div class="settings-col-block col-md-12">
      <h6>Default Crossfade</h6>
      <p class="brief">
        Set the default crossfade for all uploaded files. If you edit fade and
        cue points the custom fade and cue
        points will apply.<br />
        <strong>Note:</strong> Changing this setting will cause your station to
        reload. Any listeners currently connected will be kicked.
      </p>
      <div class="row settings-row">
        <div class="col-md-12 playout-mode">
          <form class="form-horizontal" role="form" id="playoutSettings">
            <div class="row">
                <div class="col-12">
                 
                  <div class="d-flex justify-content-between">
                       <label class="" for="crossfade">Crossfade Length</label>
                    <i class="icon icon-timer"></i
                    ><span class="crossfade-text">3 seconds</span>
                  </div>
                </div>
                <div class="col-12">
                  <input
                    name="crossfade"
                    type="range"
                    value="3"
                    min="0"
                    max="10"
                    step="1"
                    class="w-75"
                   
                  />
                </div>
            </div>
          </form>
        </div>
      </div>
    </div>
 
    <div class="settings-col-block col-md-12">
      <h6>Audio Stream Quality</h6>
      <p class="brief">
        Adjust the bitrate and format of your stream.<br /><strong>Note:</strong> Changing this setting will cause
        your station to reload. Any listeners currently connected will be
        kicked.
      </p>
      <div class="row settings-row">
        <div class="col-md-12 outputSettings">
          <div class="output-settings">
            <form class="form-horizontal" role="form" novalidate="novalidate">
              <div class="row">
                <div class="form-group">
                  <div class="col-sm-4">
                    <label for="outputFormat">Output Format</label>
                  </div>
                  <div class="col-sm-7">
                    <div class="radio-options" data-editor="">
                      <label class="radio-inline"
                        ><input
                          name="outputFormat"
                          value="MP3"
                          type="radio"
                          checked="checked"

                        />MP3</label
                      ><label class="radio-inline"
                        ><input
                          name="outputFormat"
                          value="AAC"
                          type="radio"
                        />AAC</label
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="form-group">
                  <div class="col-sm-7">
                    <label for="soundQuality">Sound Quality</label>
                    <div class="form-helper">
                      <i class="icon icon-media"></i
                      ><span class="bitrate-text">Near CD (128kbps)</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row bitrate-row">
                <div class="col-sm-7">
                  <input
                    name="soundQuality"
                    type="range"
                    value="5"
                    min="0"
                    max="8"
                    step="1"
                    class="w-75"
                  />
                </div>
              </div>
        
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="settings-col-block col-md-12 no-border">
      <div class="form-group">
        <button class="btn btn-default">Save</button>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  DISPATCH_UPGRADE,
} from "@/store/action-types";

export default {
  name: "Broadcast",

  data() {
    return {
      pageTitle: "Broadcast",
    

    };
  },



  methods: {
    getButtonClass(item) {
      return item.Name == this.mainPlan.name ? "btn-success" : "btn-info";
    },

    isCurrentPlan(item) {
      return item.Name == this.mainPlan.name ? true : false;
    },

    buttonLabel(item) {
      //console.log(item);
      const currentPlan = this.purchase?.amount;
      const CostNumber = item.CostNumber;
      // console.log(currentPlan,CostNumber);

      if (CostNumber > currentPlan) {
        return "Upgrade Plan";
      } else if (CostNumber < currentPlan) {
        return "Downgrade Plan";
      }
      return "Current Plan";
    },

    invoiceStatusCls(item) {
      return item.status == "paid" ? "badge-success" : "badge-warning";
    },

    invoiceBtnLabel(item) {
      const status = item.status;
      // console.log(status);

      if (status === "paid") {
        return "View";
      }
      return "Pay";
    },

    upgrade(item) {
      console.log(item);
      this.$store.dispatch(DISPATCH_UPGRADE, {
        id: this.stationId,
        plan_id: item.id,
      });
    },

    payInvoice(item) {
      location.href = item.payment_link;
    },
  },


};
</script>

<style scoped>
.col-circle {
  border: 1px solid #6f42c1;
  padding: 20px;
  height: 120px;
  line-height: 120px;
  width: 120px;
  display: flex; /* or inline-flex */
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.tdWidth {
  max-width: 40%;
}

/* /deep/ .table > tbody > tr > td {
  max-width: 300px;
} */
</style>
